// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"9d9ccdc4","451":"1e440323","484":"e644470a","673":"9f804eac","694":"e4f2071b"}[chunkId] + ".chunk.js";
};